module.exports = __webpack_public_path__ + "static/media/texture-practice.3a26fe45.jpg";